module.exports = [{
      plugin: require('/srv/maya/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-133559378-1"},
    }]
